// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"58":"bebd1e88","217":"d229b3e8","307":"34e7d245","739":"8a0d63a0","988":"8a0d63a0"}[chunkId] + ".chunk.css";
};